<template>
  <div>
    <Title :pages="[{ icon: 'boxes-packing', page: page_title.toUpperCase() }]"></Title>
    <v-container fluid>
      <v-card class="mb-4">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>
              <div class="row pt-2">
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_from" density="comfortable" type="date" name="creation_date_from" label="Desde" :disabled="disabled"></v-text-field>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.creation_date_to" density="comfortable" type="date" name="creation_date_to" label="hasta" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.status"
                    density="comfortable"
                    name="status"
                    item-title="name"
                    item-value="id"
                    :items="status"
                    label="Estado"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.client"
                    density="comfortable"
                    name="cliente"
                    item-title="name"
                    item-value="id"
                    :items="clients"
                    label="Cliente"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.shipment_order_code" density="comfortable" label="Número de Pedido" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.wave_code" density="comfortable" label="Número de Ola" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-3">
                  <v-text-field v-model="filters.lpn_code" density="comfortable" label="LPN" :disabled="disabled"></v-text-field>
                </div>

                <div class="col-md-3">
                  <v-combobox v-model="filters.product" density="comfortable" item-title="label" item-value="id" :items="products" label="Producto" autocomplete="off" clearable></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.almacen"
                    density="comfortable"
                    name="almacen"
                    item-title="name"
                    item-value="id"
                    :items="almacenes"
                    label="Almacen"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-3">
                  <v-combobox
                    v-model="filters.zona"
                    density="comfortable"
                    name="zona"
                    item-title="code"
                    item-value="id"
                    :items="zonas"
                    label="Zona"
                    autocomplete="off"
                    :disabled="disabled"
                    clearable
                  ></v-combobox>
                </div>

                <div class="col-md-6 pt-0 pb-3" style="display: flex; justify-content: end">
                  <v-btn color="info" class="" @click="filter" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card>
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col cols="auto">
              <span>{{ page_title }}</span>
            </v-col>
            <v-col>
              <v-btn :color="allExpanded ? 'blue-grey' : 'blue-grey'" variant="outlined" size="small" @click="toggleExpandAll" class="mr-3">
                <v-icon start>{{ allExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                {{ allExpanded ? "Contraer Todo" : "Expandir Todo" }}
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <!-- v-if="list_access" -->

        <v-data-table v-if="list_access" :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <v-btn variant="text" size="small" @click="toggleExpand(index)" icon>
                  <v-icon>{{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}</v-icon>
                </v-btn>
              </td>
              <td>{{ item.pd_id }}</td>
              <td>
                {{ item.pd_creation_date }}<br />
                <span class="text-caption text-grey-600">{{ item.user_name || "-" }}</span>
              </td>
              <td>
                <div class="font-weight-medium" :style="item.wave_id ? 'margin-top: 5px; margin-bottom: -5px' : ''">
                  {{ formatOrderCode(item.so_code) }}
                </div>
                <span class="text-caption text-grey-600">{{ item.wave_id ? "Ola " + item.wave_id : "" }}</span>
              </td>
              <td>
                {{ item.product_name }}
                <span class="text-caption text-grey-600 d-block no-wrap">SKU: {{ item.product_sku }}</span>
              </td>
              <td>{{ item.lpn_code || "" }}</td>
              <td>
                <div class="d-flex align-center gap-3 mt-1 mb-1">
                  <div v-if="item.lpn_origen_code || item.ubicacion_origen_code" class="d-flex flex-column">
                    <span class="font-weight-bold text-caption">Origen</span>
                    <span>{{ item.lpn_origen_code || "" }}</span>
                    <span class="text-caption text-grey-600 nowrap">{{ item.ubicacion_origen_code || "" }}</span>
                  </div>

                  <v-divider v-if="(item.lpn_origen_code || item.ubicacion_origen_code) && (item.lpn_destino_code || item.ubicacion_destino_code)" vertical class="mx-2"></v-divider>

                  <div v-if="item.lpn_destino_code || item.ubicacion_destino_code" class="d-flex flex-column">
                    <span class="font-weight-bold text-caption">Destino</span>
                    <span>{{ item.lpn_destino_code || "" }}</span>
                    <span class="text-caption text-grey-600 nowrap">{{ item.ubicacion_destino_code || "" }}</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="stock-row">
                  <span class="stock-label">A preparar:</span>
                  <span class="stock-value">{{ item.pd_amount_to_pick }}</span>
                </div>
                <div class="stock-row">
                  <span class="stock-label text-grey-600">Preparada:</span>
                  <span class="stock-value text-grey-600">{{ item.pt_amount_picked || "0" }}</span>
                </div>
              </td>
              <td>
                <span class="status-badge" :class="'status-' + item.pd_status">
                  {{ service.getStatusName(item.pd_status) }}
                </span>
              </td>
            </tr>
            <tr v-if="isExpanded(index)" :key="`expanded-${index}`">
              <td :colspan="headers.length" class="pa-0">
                <div class="pa-4 bg-grey-lighten-5">
                  <h6 class="mb-3 ml-4">Detalles Adicionales</h6>
                  <v-row class="ml-1">
                    <v-col cols="12" md="3">
                      <span class="font-weight-bold pb-1 text-caption">Cliente</span>
                      <div>{{ item.client_name }}</div>
                    </v-col>

                    <v-col cols="12" md="3">
                      <span class="font-weight-bold pb-1 text-caption">ID Tarea</span>
                      <div>#{{ item.pt_id }}</div>
                    </v-col>

                    <v-col cols="12" md="3" v-if="item.soi_expiration_date">
                      <span class="font-weight-bold pb-1 text-caption">Vencimiento</span>
                      <div>{{ item.soi_expiration_date }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_lote">
                      <span class="font-weight-bold pb-1 text-caption">Lote</span>
                      <div>{{ item.soi_lote }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_serie">
                      <span class="font-weight-bold pb-1 text-caption">Serie</span>
                      <div>{{ item.soi_serie }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_storage_units_amount">
                      <span class="font-weight-bold pb-1 text-caption">Almacenamiento</span>
                      <div>{{ item.soi_storage_units_amount }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_descriptivo_1 && isAliasEnabled('descriptivo_1')">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_1") }}</span>
                      <div>{{ item.soi_descriptivo_1 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_descriptivo_2 && isAliasEnabled('descriptivo_2')">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_2") }}</span>
                      <div>{{ item.soi_descriptivo_2 }}</div>
                    </v-col>
                    <v-col cols="12" md="3" v-if="item.soi_descriptivo_3 && isAliasEnabled('descriptivo_3')">
                      <span class="font-weight-bold pb-1 text-caption">{{ getAliasName("descriptivo_3") }}</span>
                      <div>{{ item.soi_descriptivo_3 }}</div>
                    </v-col>
                  </v-row>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { pickingDetailService } from "@/libs/ws/pickingDetailService";
import { almacenService } from "@/libs/ws/almacenService";
import { zonaService } from "@/libs/ws/zonaService";
import { clientService } from "@/libs/ws/clientService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import { productoService } from "@/libs/ws/productoService";
export default {
  components: {},
  mixins: [GenericMixin, RolMixin, AliasMixin],
  data() {
    return {
      service: pickingDetailService,
      page_title: "Preparacion de envios",
      modal_title: "Preparacion de envio",
      clients: [],
      almacenes: [],
      status: [],
      zonas: [],
      products: [],
      headers: [], // Will be initialized in mounted()
      filters: {
        creation_date_from: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        creation_date_to: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        document_type: null,
        status: null,
        client: null,
        almacen: null,
        product: null,
        zona: null,
        id: "",
        external_reference: "",
      },
    };
  },
  mounted() {
    this.loadAliasMap().then(() => {
      this.setupHeaders(); // Se llama luego para que exista el mapa de alias
    });

    this.filters.almacen = JSON.parse(localStorage.getItem("almacen"));

    this.loadList(this.service);
    this.loadCombobox();
  },
  methods: {
    setupHeaders() {
      this.headers = [
        { title: "", key: "data-table-expand", sortable: false, width: "48px" },
        {
          title: "Nº",
          align: "left",
          sortable: true,
          key: "pd_id",
        },
        {
          title: "Creacion",
          align: "left",
          sortable: true,
          key: "pd_creation_date",
        },
        {
          title: "Envio",
          align: "left",
          sortable: true,
          key: "so_code",
        },
        {
          title: "Producto",
          align: "left",
          sortable: true,
          key: "product_name",
        },
        {
          title: "LPN reservado",
          align: "left",
          sortable: true,
          key: "lpn_code",
        },
        {
          title: "LPN Pickeado Origen/Destino",
          align: "left",
          sortable: true,
          key: "",
        },
        {
          title: "Cantidades",
          align: "left",
          sortable: true,
          key: "",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "pd_status",
        },
      ];

      this.addDescriptiveHeaders();
    },
    addDescriptiveHeaders() {
      this.addDescriptiveHeadersToArray(this.headers, "shipment_order_item", "shipment_order_item.serie");
    },
    formatOrderCode(code) {
      return String(code).padStart(10, "0");
    },

    loadCombobox() {
      this.loadAlmacenes();
      this.loadClientes();
      this.loadStatus();
      this.loadZonas();
      this.loadProducts();
    },
    getFilterParams() {
      return this.filters;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadZonas() {
      zonaService
        .filter({ almacen: this.filters.almacen })
        .then((response) => {
          this.zonas = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadAlmacenes() {
      almacenService
        .filter({})
        .then((response) => {
          this.almacenes = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadClientes() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadStatus() {
      pickingDetailService
        .list_status()
        .then((response) => {
          this.status = response.result;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    loadProducts() {
      productoService.list_minify().then((response) => {
        this.products = response.result.list;
      });
    },
  },
};
</script>
